<section class="kyc-wrap">
  <div class="wrap-lg">
    <div class="kyc-inner">
      <div class="nav-sec">
        <div class="back-nav" (click)="gotoHome()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 6L9 12L15 18" stroke="#1A204B" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="nav-name">Back</span>
        </div>
      </div>
      <div class="page-head">
        <div class="head-left">
          <div class="page-title">Enter {{ !isMainApplicant ? 'Co-applicant' : loanDetails?.isSponser?'Sponsor': loanDetails?.isStudentMainApplicant? 'Student': 'Applicant'}} Details</div>
          <div class="page-info">Enter details as per records.</div>
        </div>
      </div>
      <div class="box-tab">
        <div class="tab-sec">
          <div class="page-steps">
            STEP
            <span class="count">{{steps}} / {{moratorium? 2 : 4}} </span>
          </div>
          <div class="primary-tab kyc-tab">
            <div class="tab-item"  [class.active]="kycTab == 'basic'"   >Basic <span class="mob-hide"> Details</span><img *ngIf="panVerified" class="input-icon" [src]="tickImage" alt="Icon" /></div>
            <div class="tab-item" [class.active]="kycTab == 'employment'" *ngIf="!moratorium">Employment <span class="mob-hide"> Details</span><img *ngIf="employmentVerified" class="input-icon" [src]="tickImage" alt="Icon" /></div>
            <div class="tab-item" [class.active]="kycTab == 'bank'" *ngIf="!moratorium" >bank <span class="mob-hide"> Details</span><img *ngIf="bankVerified" class="input-icon" [src]="tickImage" alt="Icon" /></div>
            <div class="tab-item" [class.active]="kycTab == 'KYC'" >KYC <span class="mob-hide"> Details</span><img *ngIf="kycVerified && currentApplicant.selfiNotComplete" class="input-icon" [src]="tickImage" alt="Icon" /></div>
          </div>
          <div class="color"></div>
        </div>
        <div class="tab-content">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</section>

